/* Integrations page, after the click demo's cards and confirm dialog. */
.main {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
  padding: 28px 40px 48px;
  overflow-y: auto;
  min-width: 0;
}

.empty {
  margin: 0;
  color: var(--muted);
}

.emptyPage {
  composes: main;
  color: var(--muted);
}

.grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: var(--space-4);
}

.card {
  background: var(--surface);
  border-radius: 12px;
  box-shadow: 0 3px 8px rgb(2 48 71 / 10%);
  padding: var(--space-4) 22px;
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.head {
  display: flex;
  align-items: center;
  gap: 14px;
}

.tile {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: none;
  font-weight: 900;
  font-size: 22px;
  background: var(--accent);
  color: var(--accent-text);
}

.name {
  margin: 0;
  font-size: 19px;
}

.pill {
  display: inline-flex;
  margin-top: 6px;
  white-space: nowrap;
  border-radius: 999px;
  padding: 3px 10px;
  font-size: 12px;
  font-weight: 700;
}

.on {
  composes: pill;
  background: var(--accent);
  color: var(--accent-text);
}

.off {
  composes: pill;
  background: var(--surface-2);
  color: var(--text);
}

.description {
  margin: 0;
  line-height: 1.5;
}

.facts {
  display: grid;
  grid-template-columns: 100px minmax(0, 1fr);
  gap: 6px 12px;
  margin: 0;
}

.facts dt {
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--muted);
}

.facts dd {
  margin: 0;
}

.actions {
  margin-top: auto;
}

.button {
  display: inline-flex;
  align-items: center;
  min-height: 44px;
  padding: 0 18px;
  border: none;
  border-radius: var(--radius);
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
  text-decoration: none;
}

.connect {
  composes: button;
  background: var(--accent);
  color: var(--accent-text);
}

.secondary {
  composes: button;
  background: var(--surface-2);
  color: var(--text);
}

.confirm {
  composes: button;
  background: var(--eyebrow);
  color: #ffffff;
}

.notice {
  display: flex;
  align-items: center;
  gap: var(--space-3);
  background: var(--warning-soft);
  border-radius: var(--radius);
  padding: var(--space-2) var(--space-2) var(--space-2) 16px;
}

.notice span {
  flex: 1;
}

.close {
  width: 44px;
  height: 44px;
  border: none;
  background: transparent;
  color: var(--text);
  font-size: 22px;
  cursor: pointer;
}

.backdrop {
  position: fixed;
  inset: 0;
  background: rgb(2 48 71 / 55%);
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 140px var(--space-4) var(--space-4);
  z-index: 20;
}

.dialog {
  background: var(--surface);
  border-radius: 14px;
  box-shadow: 0 12px 32px rgb(2 48 71 / 35%);
  padding: 24px 26px;
  width: 100%;
  max-width: 460px;
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.dialogTitle {
  margin: 0;
  font-size: 22px;
}

.dialogActions {
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  flex-wrap: wrap;
}

@media (max-width: 720px) {
  .main {
    padding: var(--space-4) 16px 32px;
  }

  .grid {
    grid-template-columns: 1fr;
  }

  .backdrop {
    padding-top: 48px;
  }
}
